<app-wizard-modal (stepChange)="onStepChange($event)"
                  (stepErrorsChange)="onStepErrosChange()"
                  [isLoading]="isLoading"
                  (cancel)="onCancel()"
                  (submit)="onSubmit()">
    <app-wizard-title>{{ 'admin.tickets.create-modal.title' | translate }}</app-wizard-title>
    <app-wizard-step [canContinue]="selectToolsForm.valid">
        <ng-template #title>{{ 'admin.tickets.create-modal.sections.scanTools' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <div class="info-message" *ngIf="this.firstTool"><i
                class="material-icons">warning</i> {{ getInfoMessage() }}
            </div>
            <form [formGroup]="selectToolsForm">
                <div class="step-content step-one">
                    <div class="row">
                        <div class="col s12">
                            <app-tool-scan-tree
                                labelText="{{'admin.tickets.create-modal.issueToolScan.title' | translate}}"
                                emptyMessage="{{'tree.toolSelect.emptyMessage' | translate}}"
                                class="toolScanner"
                                formControlName="selectedTools"
                                [isMaterial]="false"
                                [mode]="'scan'"
                                [config]="config"
                                [formControl]="selectToolsForm.controls['selectedTools']"
                                [showErrors]="step.nextTriggered"
                                [isScanListenerActive]="isOpen()"
                                [items]="selectedTools"
                                (toolSelect)="onToolScan($event)"
                            ></app-tool-scan-tree>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="canContinueStep1()">
        <ng-template #title>{{ 'admin.tickets.create-modal.sections.ticketDetails' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <form [formGroup]="operationsForm">
                <div class="row" *ngIf="toolReturn && toolReturn.reason">
                    <app-textbox label="{{'admin.tickets.details-modal.panel.lineInfo' | translate}}"
                                 class="line-info"
                                 [value]="toolReturn?.reason">
                    </app-textbox>
                </div>
                <div class="row">
                    <app-textarea [formControl]="operationsForm.controls['description']"
                               [showErrors]="showValidations"
                               placeholder="{{'admin.tickets.create-modal.description-input.placeholder' | translate }}"
                               label="{{'admin.tickets.create-modal.description-input.label' | translate}}">
                    </app-textarea>
                    <app-input-switch
                        onLabel="{{'generic.yes' | translate}}"
                        offLabel="{{'generic.no' | translate}}"
                        topLabel="{{'admin.tickets.create-modal.hasPriority' | translate}}"
                        [formControl]="operationsForm.controls['hasPriority']"></app-input-switch>
                </div>
                <div class="row">
                    <app-picklist
                        [source]="availableOperations"
                        [(target)]="operationsForm.value.operationTypes"
                        [formControl]="operationsForm.controls.operationTypes"
                        [showValidations]="showValidations"
                        sourceHeader="{{'admin.tickets.create-modal.operation-types-input.leftHeader' | translate}}"
                        targetHeader="{{'admin.tickets.create-modal.operation-types-input.rightHeader' | translate}}"
                        infoLabel="{{'admin.tickets.create-modal.alert.message' | translate}}">
                    </app-picklist>
                </div>
            </form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step *ngIf="toolsHaveMaintenancePlan()" [canContinue]="operationsWithRecurrencesForm.valid">
        <ng-template #title>{{ 'admin.tickets.create-modal.sections.ticketRecurrences' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <div *ngIf="isLoading" class="loading">
                <app-loading-spinner></app-loading-spinner>
            </div>
            <form *ngIf="!isLoading" [formGroup]="operationsWithRecurrencesForm">
                <div class="button-container">
                    <app-button (click)="openRevisionModal()">
                        {{ 'admin.tickets.create-modal.revisionInfo.modal-button' | translate }}
                    </app-button>
                </div>
                <app-activities-form [formControl]="operationsWithRecurrencesForm.controls['selectedRecurrencesItems']"
                                     [items]="selectedRecurrencesItems"
                                     [activities]="operationsWithRecurrences">
                </app-activities-form>
            </form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canSave]="!isLoading" [saveDisabled]="hasSimilarTicketsInProgress()">
        <ng-template #title>
            <div [innerHTML]="'admin.tickets.create-modal.sections.ticketOverview' | translate">
            </div>
        </ng-template>
        <ng-template #content
                     let-step="step">
            <div *ngIf="isLoading" class="loading">
                <app-loading-spinner></app-loading-spinner>
            </div>
            <div *ngIf="!isLoading">
                <div [innerHTML]="computeOverviewStepDescription()"
                     style="margin-bottom: 1rem"></div>
                <app-tree class="similarTickets"
                          emptyMessage="{{'admin.tickets.create-modal.overview.empty-message' | translate}}"
                          [parameters]="[{'value': 'date' , 'label':'admin.tickets.create-modal.overview.date' },
                                   {'value': 'tools', 'label':'admin.tickets.create-modal.overview.tools'},
                                   {'value': 'operations', 'label':'admin.tickets.create-modal.overview.operations'},
                                   {'value': 'description', 'label':'admin.tickets.create-modal.overview.description'}]"
                          [items]="computeSimilarTickets()">
                </app-tree>
                <app-ticket-overview *ngIf="toolsHaveMaintenancePlan()"
                                     [overviewItems]="overviewItems"
                                     [description]="this.operationsForm.controls.description.value"
                                     (goTo)="goToPlan($event)">
                </app-ticket-overview>
            </div>

        </ng-template>
    </app-wizard-step>
</app-wizard-modal>

<app-revision-info-modal title="{{'admin.tickets.create-modal.revisionInfo.title' | translate}}">
</app-revision-info-modal>
